<template>
  <v-container class="py-6">
    <h1 class="text-h6 mb-4">
      Smoke: Vylepšit článek z URL — tabulky Pro AI Lucy
    </h1>
    <div class="kw-pair d-flex flex-wrap">
      <KeywordsList
        class="flex-grow-1"
        :keyword-type="KeywordType.RELATED"
        :keywords="relatedKeywords"
        :read-only="workspaceReadOnly"
        :article="article"
        current-selected-keyword="jak investovat"
        :selected-for-ai.sync="selectedForAi"
      />
      <KeywordsList
        class="flex-grow-1"
        :keyword-type="KeywordType.QUESTION"
        :keywords="questionKeywords"
        :read-only="workspaceReadOnly"
        :article="article"
        current-selected-keyword="jak investovat"
        :selected-for-ai.sync="selectedForAi"
      />
    </div>
  </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {KeywordType} from '@/enum/keyword_type';
    import KeywordsList from '@/components/keywords/KeywordsList.vue';
    import {Article} from '@/model/Article';
    import {isKeywordWorkspaceTableLocked} from '@/service/keywordWorkspaceTableLock';
    import {I18n} from '@/plugins/I18n';

    /** Local-only fixture: same lock inputs ArticleView + KeywordSelection use on URL improve. */
    export default Vue.extend({
        name: 'UrlImproveLucySmokeView',
        components: {KeywordsList},
        created() {
            I18n.locale = 'cs';
            this.$store.commit('setKeywordSelectionShown', true);
        },
        data: () => {
            const article = new Article();
            article.isAnalyze = true;
            article.keyword = 'jak investovat';
            article.selectedKeyword = 'jak investovat';
            article.enhanced = 'pending';
            article.url = 'https://example.com/jak-investovat';
            article.h1 = [{
                uid: 1,
                h: 'Jak investovat',
                p: 'Úvodní text načtený z URL — workspace musí zůstat editovatelný.',
            }];
            article.metaTitle = 'Jak investovat';
            return {
                KeywordType,
                article,
                selectedForAi: [
                    {keyword: 'jak začít investovat', intent: 'section'},
                ] as Array<{keyword: string; intent: string}>,
                relatedKeywords: [
                    {keyword: 'jak investovat', keyword_info: {search_volume: 751}},
                    {keyword: 'jak začít investovat', keyword_info: {search_volume: 479}},
                    {keyword: 'jak investovat do akcií', keyword_info: {search_volume: 320}},
                ],
                questionKeywords: [
                    {keyword: 'Kam uložit 100.000 Kč?', keyword_info: {search_volume: 210}},
                    {keyword: 'Kam investovat 1000 Kč měsíčně?', keyword_info: {search_volume: 180}},
                ],
            };
        },
        computed: {
            workspaceReadOnly(): boolean {
                return isKeywordWorkspaceTableLocked({
                    sharePreview: false,
                    enhancingOverride: false,
                    articleMetadata: this.article,
                    keywordSelectionShown: this.$store.getters.keywordSelectionShown,
                    readOnly: true,
                });
            },
        },
    });
</script>
